import React from "react"
import CustomButton, { CustomButtonProps } from "../Atoms/CustomButton"

const ActionButton = ({ ...otherProps }: CustomButtonProps) => (
  <CustomButton {...otherProps} />
)

ActionButton.defaultProps = {
  text: "Actions",
  icon: "menu",
}
export default ActionButton
